<template>
  <div class="headbar" :style="{'background':themeColor}"
    :class="$store.state.app.collapse?'position-collapse-left':'position-left'">
    <!-- 导航收缩 -->
    <!--<span class="hamburg">-->
      <!--<el-menu class="el-menu-demo" :background-color="themeColor" text-color="#fff" :active-text-color="themeColor" mode="horizontal">-->
        <!--&lt;!&ndash;<el-menu-item index="1" @click="onCollapse"><hamburger :isActive="collapse"></hamburger></el-menu-item>&ndash;&gt;-->
      <!--</el-menu>-->
    <!--</span>-->
    <!-- 导航菜单 -->

    <!-- 工具栏 -->
    <span class="toolbar">
      <el-menu class="el-menu-demo" :background-color="themeColor" :text-color="themeColor" :active-text-color="themeColor" mode="horizontal">
        <el-menu-item index="5">
          <!-- 用户信息 -->

          <el-dropdown  trigger="click">
                <span class="user-info">{{user.name}}</span>
           <el-dropdown-menu slot="dropdown">
             <el-dropdown-item>
               <!--<router-link to="/site/update-pwd" style="text-decoration: none">-->
                 <!--&lt;!&ndash;<i class="fa fa-lock"></i>&ndash;&gt;-->
                 <!--&nbsp;修改密码</router-link>-->
               <span @click="handleEdit">
                 &nbsp;修改密码</span>
             </el-dropdown-item>
             <el-dropdown-item>
               <span @click="logout">
                 <!--<i class="fa fa-sign-out"></i>-->
                 &nbsp;退出登录</span>
             </el-dropdown-item>
           </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </el-menu>
    </span>



    <el-dialog :title="'编辑'" :visible.sync="formVisible" :close-on-click-modal="false" :show-close="false" :modal="false" width="600px">
      <el-form :model="formAgtEdit" label-width="100px" :rules="rules" :ref="formAgtEdit">
        <el-form-item label="旧密码" prop="pwd">
          <el-input v-model="formAgtEdit.pwd"/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="formAgtEdit.newPwd"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset(formAgtEdit)">取消</el-button>
        <el-button type="primary" @click.native="handleSubmit(formAgtEdit)" :loading="formLoading">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import Cookies from "js-cookie"
import { mapState } from 'vuex'
import {updatePwd} from "../../api/api";

export default {
  data() {
    return {
      user: {
        name: "admin"
      },
      formAgtEdit: {},
      // //对话框隐藏状态
      formVisible: false,
      //表单提交状态
      formLoading: false,
      //验证规则
      rules: {
        pwd: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        newPwd: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }]
      },
    }
  },
  methods: {
    // openWindow(url) {
    //   window.open(url)
    // },
    // selectNavBar(key, keyPath) {
    //   console.log(key, keyPath)
    // },
    // // 折叠导航栏
    // onCollapse: function() {
    //   this.$store.commit('onCollapse')
    // },

    //退出登录
    logout: function () {

      let _this = this

      this.$confirm("确认退出吗", "提示" ,{
          type: "warning"
      }).then(() => {
        //清除本地缓存的用户信息
        localStorage.removeItem('user')
        //清除Cookie中的信息
        Cookies.remove('token')

        location.reload()

        _this.$router.push({
          path: '/login '
        })
      })
    },

    //弹框
    handleEdit : function () {
      this.formAgtEdit = {}

      this.formVisible = true
    },

    //表单重置
    reset: function (formName) {
      this.$refs[formName].resetFields();

      this.formVisible = false
    },

    //密码校验
    checkPwd : function (val) {
      return (/^[0-9]{6}$/.test(val))
    },

    //数据提交
    handleSubmit : function (formName) {
      let _this = this

      if (!_this.checkPwd(this.formAgtEdit.pwd)) {

        _this.$message({
          showClose: true,
          message: '请输入6位数字的旧密码',
          type: 'error'
        });
        return
      }
      if (!_this.checkPwd(_this.formAgtEdit.newPwd)) {

        _this.$message({
          showClose: true,
          message: '请输入6位数字的新密码',
          type: 'error'
        });
        return
      }
      _this.$refs[formName].validate(valid => {

        if (!valid) {
          return
        }

        _this.formLoading = true
        _this.formAgtEdit["userName"] = localStorage.getItem('user')

        updatePwd(_this.formAgtEdit).then(res => {
          _this.formLoading = false

          if (res.data.code === '200') {
            const loading = _this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });
            setTimeout(() => {
              loading.close();

              //清除本地缓存的用户信息
              localStorage.removeItem('user')
              //清除Cookie中的信息
              Cookies.remove('token')

              _this.$router.push({
                path: '/login '
              })

            }, 2000);
          }else {

            _this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error'
            });
            return
          }
          _this.formVisible = false
        }).catch(e => _this.formVisible = false)

      })

    }

  },
  mounted() {
    this.sysName = "后台管理系统"
    var user = localStorage.getItem("user")
    if (user) {
      this.user.name = user
      // this.user.avatar = require("@/assets/user.png")
    }
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor,
      collapse: state=>state.app.collapse
    })
  }
}
</script>

<style lang="scss">
.headbar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1030;
  height: 60px;
  line-height: 60px;
  border-color: rgba(180, 190, 190, 0.8);
  border-left-width: 1px;
  border-left-style: solid;
}
.hamburg, .navbar {
  float: left;
}
.toolbar {
  float: right;
}
.lang-item {
  font-size: 16px;
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}
.lang-item:hover {
  font-size: 18px;
  background: #b0d6ce4d;
}
.user-info {
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 10px 0px 10px 10px;
    float: right;
  }
}
.badge {
  line-height: 18px;
}
.position-left {
  left: 200px;
}
.position-collapse-left {
  left: 65px;
}
.personal-panel {
  top: 50px;
  font-size: 14px;
  width: 280px;
  text-align: center;
  border-color: rgba(180, 190, 190, 0.2);
  border-width: 1px;
  /*border-style: solid;*/
  background: rgba(182, 172, 172, 0.1);
  margin: 14px;
}
.modify-box {
   left: 50%!important;
   margin-left: -164px!important;
  top: 25%!important;
}

.main-operation {
  margin-right: 1px;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.personal-footer {
  /*margin-right: 1px;*/
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.zlf-form{
  margin-top: -75px!important;
  margin-left: 1550px!important;
  margin-right: -230px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/HeadBar/HeadBar.vue